export default __webpack_public_path__ + "static/media/someta_resize.8f674ace.png";